import React from "react";
import { formatCents, plural } from "./towerFormat";
import type { TowerCounts } from "../../types/controlTower";

const ICONS = {
  collection: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M15 9.5c-.5-1-1.6-1.5-3-1.5-1.7 0-3 .9-3 2.1 0 2.8 6 1.4 6 4.2 0 1.2-1.3 2.2-3 2.2-1.5 0-2.6-.6-3.1-1.6M12 6.5v1.5M12 16.5V18" />
    </>
  ),
  exchange: <path d="M7 7h12l-3-3M17 17H5l3 3" />,
  pickup: <path d="M21 8l-9-5-9 5 9 5 9-5zM3 8v8l9 5 9-5V8M12 13v8" />,
  meli: (
    <>
      <path d="M3 6h11v9H3zM14 9h4l3 3v3h-7" />
      <circle cx="7" cy="17" r="2" />
      <circle cx="17" cy="17" r="2" />
    </>
  ),
};

function Extra({ kind, title, detail }: { kind: keyof typeof ICONS; title: React.ReactNode; detail: string }) {
  return (
    <div className="tower-extra">
      <span className={`tower-extra-icon ${kind}`} aria-hidden="true">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          {ICONS[kind]}
        </svg>
      </span>
      <div>
        <strong>{title}</strong>
        <small>{detail}</small>
      </div>
    </div>
  );
}

// Detalle del chofer: cobros, cambios, retiros y lo reprogramado por Meli,
// como tarjetas chicas con ícono. No se muestra si no tiene ninguno.
export default function DriverExtras({ counts }: { counts: TowerCounts }) {
  if (!counts.collections && !counts.exchanges && !counts.pickups && !counts.delayed) return null;
  return (
    <div className="tower-dialog-extras">
      {counts.collections > 0 && (
        <Extra
          kind="collection"
          title={
            <>
              {plural(counts.collections, "cobro")} <b>{formatCents(counts.collectionCents)}</b>
            </>
          }
          detail={`Cobrado ${formatCents(counts.collectedCents)}`}
        />
      )}
      {counts.exchanges > 0 && (
        <Extra kind="exchange" title={plural(counts.exchanges, "cambio")} detail="Devolución y entrega" />
      )}
      {counts.pickups > 0 && (
        <Extra kind="pickup" title={plural(counts.pickups, "retiro")} detail="Buscar en el domicilio" />
      )}
      {counts.delayed > 0 && (
        <Extra kind="meli" title={`${counts.delayed} en camino`} detail="Reprogramados por Meli" />
      )}
    </div>
  );
}
